import React from "react";
import Select from "react-select";

const TaxPicker = ({ action, value, disabled = false }) => {
	const options = [
		{ value: "state", label: "State" },
		{ value: "county", label: "County" },
		{ value: "exempt", label: "Exempt" },
	];
	return (
		<div>
			<Select
				value={value}
				options={options}
				placeholder="Select"
				onChange={action}
				isDisabled={disabled}
			/>
		</div>
	);
};

export default TaxPicker;
